import ClusterIcon from "../images/ClusterIcon.mjs";

const AppPalleIcon = class extends ClusterIcon{};

export default AppPalleIcon;
